import { mapGetters, mapState } from 'vuex';

import formatterMixin from './formatterMixin';

const comfortCreditsMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      loading: (state) => state.comfortCredits.loading,
      activeTab: (state) => state.comfortCredits.activeTab,
      ccMembers: (state) => state.comfortCredits.ccMembers,
      ccTableOptions: (state) => state.comfortCredits.ccTableOptions,
      ccTableSearch: (state) => state.comfortCredits.ccTableSearch,
      voucherTableSearch: (state) => state.comfortCredits.voucherTableSearch,
      ccCustomers: (state) => state.comfortCredits.ccCustomers,
      ccSelectedCustomer: (state) => state.comfortCredits.ccSelectedCustomer,
      showActionModal: (state) => state.comfortCredits.showActionModal,
      actionModalView: (state) => state.comfortCredits.actionModalView,
      processing: (state) => state.comfortCredits.processing,
      selectedCorp: (state) => state.comfortCredits.selectedCorp,
      sortedCorporation: (state) => state.comfortCredits.sortedCorporation,
      transactions: (state) => state.comfortCredits.transactions,
      selectedCustomer: (state) => state.comfortCredits.selectedCustomer,
      comfortError: (state) => state.comfortCredits.comfortError,
      selectedLoyaltyProgramName: (state) => state.comfortCredits.selectedLoyaltyProgramName,
      selectedPartnerSetting: (state) => state.comfortCredits.selectedPartnerSetting,
      balanceAsOfDate: (state) => state.comfortCredits.balanceAsOfDate,
      lastCCDate: (state) => state.comfortCredits.lastCCDate,
      plans: (state) => state.comfortCredits.plans,
      selectedPlan: (state) => state.comfortCredits.selectedPlan,
      vouchers: (state) => state.comfortCredits.vouchers,
      showRightSidebar: (state) => state.comfortCredits.showRightSidebar,
      voucherType: (state) => state.comfortCredits.voucherType,
      redeemed: (state) => state.comfortCredits.redeemed,
      transaction: (state) => state.comfortCredits.transaction,
      ccFilters: (state) => state.comfortCredits.ccFilters,
      filterTableTab: (state) => state.comfortCredits.filterTableTab,
      voucherTableOptions: (state) => state.comfortCredits.voucherTableOptions,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'partnerSettings',
      'ccMemberTableRecordCount',
      'voucherTableRecordCount',
      'ccMemberTableData',
      'voucherTableData',
      'allBranches',
    ]),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch('ccChangeTableOption', {
        field: 'page',
        value: page,
      });
    },
    selectCustomer(cc) {
      this.$store.dispatch('changeComfortCreditValues', [{
        field: 'ccSelectedCustomer',
        value: cc,
      },
      {
        field: 'selectedLoyaltyProgramName',
        value: cc.loyaltyName,
      },
      {
        field: 'showActionModal',
        value: true,
      },
      {
        field: 'actionModalView',
        value: 'comfort-credit',
      },
      {
        field: 'comfortError',
        value: {},
      }]);
    },
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changeComfortCreditValue', {
          field: 'showActionModal',
          value: false,
        });
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        this.$store.dispatch('changeComfortCreditValues', changes);
      }
    },
    changeTab(tab) {
      this.$store.dispatch('changeComfortCreditValues', [{
        field: 'activeTab',
        value: tab,
      }]);
      if (tab === 'credits') {
        this.$store.dispatch('getComfortCredits');
      }
      else {
        this.$store.dispatch('getCorpVouchers');
      }
    },
    async postNewComfortCredit(amount, reason) {
      await this.$store.dispatch('postComfortCredits', {
        amount,
        reason,
      });
    },
    changePartner(corpId) {
      this.$store.dispatch('changeComfortCreditValues', [
        {
          field: 'selectedCorp',
          value: corpId,
        },
        {
          field: 'selectedPlan',
          value: -1,
        },
      ]);
      this.$store.dispatch('getComfortCredits');
      this.$store.dispatch('getCorpVouchers');
    },
    changeComfortCreditValue(field, value) {
      this.$store.dispatch('changeComfortCreditValues', [{
        field,
        value,
      }]);
    },
    changeComfortCreditValues(changes) {
      this.$store.dispatch('changeComfortCreditValues', changes);
    },
  },
};

export default comfortCreditsMixin;
